import { Injectable } from "@angular/core"

import { LexTranslateService } from "@app/core/services/lex-translate.service"
import { NgbDatepickerI18n, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap"

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  i18nValues = {
    weekdays: [
      "",
      "f87c6fe5-a5ed-4df5-9e42-ebea21faadba",
      "f8ced4a7-fac0-4256-949f-ce1c83ef3223",
      "638dd17f-9d98-4389-9200-f9a65fe66891",
      "12988180-a2d0-46a5-8206-674ef51940de",
      "edb87b01-108b-44d8-81ec-9594945d313c",
      "3eade1d4-bcd5-4b49-af4e-fc4c6efece4b",
      "3a8fba57-cd03-4a94-b834-d38f9eeb8852",
    ],
    months: [
      "5e0c7d38-052e-4b6c-85d6-ccb79b3a6bf1",
      "845595df-106f-4b8d-946c-02484d1a03f3",
      "e56e3115-d104-403b-8e5a-d826ac027296",
      "a82a76cd-0c8d-4fc3-b421-6f40370cf208",
      "72076357-f571-4688-ab39-fddc86be1613",
      "fdb5760d-f8d8-4b2b-99d6-4a2f69fbe3de",
      "31dcb149-88e2-4145-9350-d584d786e041",
      "784908dc-aab5-4241-9300-bce117ec8573",
      "fcd465f6-3375-4503-b321-04b28f9a540e",
      "924d5e94-4445-4267-91f5-59a1b11dfdbc",
      "36e20856-0eaf-46fc-a90a-3d51857a7d14",
      "1711e07b-ac6a-4e24-9e81-250d4e8ac057",
    ],
  }

  constructor(private lextranslate: LexTranslateService) {
    super()
  }

  getWeekdayShortName(weekday: number): string {
    return this.lextranslate.i18n[this.i18nValues.weekdays[weekday]]
  }

  getMonthShortName(month: number): string {
    return this.lextranslate.i18n[this.i18nValues.months[month - 1]]
  }

  getMonthFullName(month: number): string {
    return this.getMonthShortName(month)
  }

  getWeekdayLabel(weekday: number): string {
    return this.getWeekdayShortName(weekday)
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`
  }
}
